<template>
  <div class="home" ref="home">
    <div class="home-header" @click="toggleFullScreen">
      蓝格赛智慧物流（履约宝）平台
    </div>
    <div style="color: #fff;font-size: 18px;text-align: center">
      <span style="padding: 0 10px">
      <i class="el-icon-date"></i>&nbsp;<span>{{ this.nowDate }}</span>  </span>
      <span style="padding: 0 10px">
              <i class="el-icon-tickets"></i>&nbsp;<span>当日行总数 {{ this.totalOrderLines }}</span>
      </span>
      <span style="padding: 0 10px">
              <i
                class="el-icon-document-delete"></i>&nbsp; <span>取消行数 {{ this.cancelOrderLines }}</span>
      </span>
    </div>
    <div class="home-main">
      <simple-chart class="order-map" :option="mapChart.option"
                    style="width: 80%;height: 80%;margin:0 auto"></simple-chart>
      <div class="order-num-wrap">
        <div class="order-num-title">订单总数</div>
        <div class="order-num-content">
          <div class="order-num-tag">{{ this.allOrders[0] }}</div>
          <div class="order-num-tag">{{ this.allOrders[1] }}</div>
          <div class="order-num-tag">{{ this.allOrders[2] }}</div>
          <div class="order-num-tag">{{ this.allOrders[3] }}</div>
          <div class="order-num-tag">{{ this.allOrders[4] }}</div>
          <div class="order-num-tag">{{ this.allOrders[5] }}</div>
        </div>
      </div>
      <div class="order-status-wrap">

      </div>
      <div class="info-wrap"
           style="position: absolute;top:170px;left:10px;padding: 0px 20px 30px 10px;">
        <div class="info-title">订单统计</div>
        <div class="order-status-tag order-hover" @click="toOrderPage">
          <div style="    margin-bottom: 20px;
    margin-top: 20px;"><img src="../assets/img/onWay.png"/></div>
          <div class="order-status-title">在途订单</div>
          <div class="order-status" style="color: #fff">{{ this.sendOrders }}</div>
        </div>
        <div class="order-status-tag order-hover" @click="toOrderPage">
          <div style="    margin-bottom: 20px;
    margin-top: 20px;"><img src="../assets/img/sign.png"/></div>
          <div class="order-status-title">已签收</div>
          <div class="order-status" style="color: #fff">{{ this.receivedOrders }}</div>

        </div>
      </div>
      <div class="info-wrap" style="position: absolute;top:500px;left:10px;">
        <div class="info-title">预警统计表</div>
        <div class="info-content" style="margin-top: 20px">
          <simple-chart :option="order.option" style="width: 370px;height: 250px;"></simple-chart>
        </div>
      </div>
      <div class="info-wrap" style="position: absolute;top:20px;right:10px;">
        <div class="info-title">月订单出库率</div>
        <div class="info-content">
          <simple-chart :option="deliveryRate.option"
                        style="width: 370px;height: 145px;"></simple-chart>
        </div>
      </div>
      <div class="info-wrap" style="position: absolute;top:215px;right:10px">
        <div class="info-title">销售行数统计</div>
        <div class="info-content">
          <simple-chart :option="orderTop10Chart.option"
                        style="width: 370px;height: 250px;"></simple-chart>
        </div>
      </div>
      <div class="info-wrap" style="position: absolute;top:520px;right:10px">
        <div class="info-title">订单年度行数统计</div>
        <div class="info-content">
          <simple-chart :option="logisticChart.option"
                        style="width: 370px;height: 250px"></simple-chart>
        </div>
      </div>
      <div
        style="position: absolute;bottom:20px;;height: 200px;width: 100%">
        <div style="margin: 0 auto;width: 560px">
          <div class="order-status-tag">
            <div class="time-graph">
              <canvas ref="issued" width="160" height="160" class="cricle-rate"></canvas>
            </div>
            <div class="order-status" style="color: #fff">{{ this.issued }}</div>
            <div class="order-status-title">已经下发量</div>
          </div>
          <div class="order-status-tag" style="margin-top: 0px">
            <div class="time-graph">
              <canvas ref="picking" width="160" height="160" class="cricle-rate"></canvas>
            </div>
            <div class="order-status" style="color: #fff">{{ this.picking }}</div>
            <div class="order-status-title">已经拣货量</div>
          </div>
          <div class="order-status-tag" style="margin-top: 0px">
            <div class="time-graph">
              <canvas ref="review" width="160" height="160" class="cricle-rate"></canvas>
            </div>
            <div class="order-status" style="color: #fff">{{ this.review }}</div>
            <div class="order-status-title">已经复核量</div>
          </div>
          <div class="order-status-tag" style="margin-top: 0px">
            <div class="time-graph">
              <canvas ref="send" width="160" height="160" class="cricle-rate"></canvas>
            </div>
            <div class="order-status" style="color: #fff">{{ this.send }}</div>
            <div class="order-status-title">已经发货量</div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import SimpleChart from '../components/SimpleChart';
import chinaMapData from '../assets/china.json';
// eslint-disable-next-line import/order
const echarts = require('echarts');

// 注册中国地图
echarts.registerMap('china', chinaMapData);
import {
  findTopTenSales,
  getDateOrderLines,
  getHome,
  getMapDatas,
  getMOnthCheckOutRate,
  getYearOrders,
} from '../api/home';
import {getTxt} from "../api/order";

async function getData() {
  const result = await getHome();
  if (result.code === 1200) {
    this.overTime = result.data.overTime;
    this.abnormal = result.data.abnormal;
    this.allOrders = result.data.allOrders;
    this.sendOrders = result.data.sendOrders;
    this.receivedOrders = result.data.receivedOrders;
    const obj = {};
    obj.name = '超时未送达';
    obj.value = result.data.overTime;
    const obj2 = {};
    obj2.name = '状态异常';
    obj2.value = result.data.abnormal;
    this.order.option.series[0].data.push(obj);
    this.order.option.series[0].data.push(obj2);
  }
  const resData = await findTopTenSales();
  if (resData.code === 1200) {
    this.orderTop10Chart.option.yAxis.data = resData.data.x.reverse();
    this.orderTop10Chart.option.series[0].data = resData.data.y.reverse();
  }
  const yearsOrder = await getYearOrders();
  if (yearsOrder.code === 1200) {
    this.logisticChart.option.xAxis.data = yearsOrder.data.x;
    this.logisticChart.option.series[0].data = yearsOrder.data.y;
  }
  const rate = await getMOnthCheckOutRate();
  if (rate.code === 1200) {
    this.deliveryRate.option.xAxis.data = rate.data.x;
    this.deliveryRate.option.series[0].data = rate.data.y;
  }
  const mapData = await getMapDatas();
  if (mapData.code === 1200) {
    const geoCoordMap = {
      上海市: [121.4648, 31.2891],
      上海: [121.4648, 31.2891],
      东莞市: [113.8953, 22.901],
      东莞: [113.8953, 22.901],
      东营: [118.7073, 37.5513],
      东营市: [118.7073, 37.5513],
      中山: [113.4229, 22.478],
      中山市: [113.4229, 22.478],
      临汾: [111.4783, 36.1615],
      临汾市: [111.4783, 36.1615],
      临沂: [118.3118, 35.2936],
      临沂市: [118.3118, 35.2936],
      丹东: [124.541, 40.4242],
      丹东市: [124.541, 40.4242],
      丽水: [119.5642, 28.1854],
      丽水市: [119.5642, 28.1854],
      乌鲁木齐: [87.9236, 43.5883],
      佛山: [112.8955, 23.1097],
      佛山市: [112.8955, 23.1097],
      保定: [115.0488, 39.0948],
      保定市: [115.0488, 39.0948],
      兰州: [103.5901, 36.3043],
      兰州市: [103.5901, 36.3043],
      包头: [110.3467, 41.4899],
      包头市: [110.3467, 41.4899],
      北京市: [116.4551, 40.2539],
      北京: [116.4551, 40.2539],
      北海: [109.314, 21.6211],
      北海市: [109.314, 21.6211],
      南京: [118.8062, 31.9208],
      南京市: [118.8062, 31.9208],
      南宁: [108.479, 23.1152],
      南宁市: [108.479, 23.1152],
      南昌: [116.0046, 28.6633],
      南昌市: [116.0046, 28.6633],
      南通: [121.1023, 32.1625],
      南通市: [121.1023, 32.1625],
      厦门: [118.1689, 24.6478],
      厦门市: [118.1689, 24.6478],
      台州: [121.1353, 28.6688],
      台州市: [121.1353, 28.6688],
      合肥: [117.29, 32.0581],
      合肥市: [117.29, 32.0581],
      呼和浩特: [111.4124, 40.4901],
      咸阳: [108.4131, 34.8706],
      咸阳市: [108.4131, 34.8706],
      哈尔滨: [127.9688, 45.368],
      哈尔滨市: [127.9688, 45.368],
      唐山: [118.4766, 39.6826],
      唐山市: [118.4766, 39.6826],
      嘉兴: [120.9155, 30.6354],
      嘉兴市: [120.9155, 30.6354],
      大同: [113.7854, 39.8035],
      大同市: [113.7854, 39.8035],
      大连: [122.2229, 39.4409],
      大连市: [122.2229, 39.4409],
      天津: [117.4219, 39.4189],
      天津市: [117.4219, 39.4189],
      太原: [112.3352, 37.9413],
      太原市: [112.3352, 37.9413],
      威海: [121.9482, 37.1393],
      威海市: [121.9482, 37.1393],
      宁波: [121.5967, 29.6466],
      宁波市: [121.5967, 29.6466],
      宝鸡: [107.1826, 34.3433],
      宝鸡市: [107.1826, 34.3433],
      宿迁: [118.5535, 33.7775],
      宿迁市: [118.5535, 33.7775],
      常州: [119.4543, 31.5582],
      常州市: [119.4543, 31.5582],
      广州市: [113.5107, 23.2196],
      广州: [113.5107, 23.2196],
      廊坊: [116.521, 39.0509],
      廊坊市: [116.521, 39.0509],
      延安: [109.1052, 36.4252],
      延安市: [109.1052, 36.4252],
      张家口: [115.1477, 40.8527],
      张家口市: [115.1477, 40.8527],
      徐州: [117.5208, 34.3268],
      徐州市: [117.5208, 34.3268],
      德州: [116.6858, 37.2107],
      德州市: [116.6858, 37.2107],
      惠州: [114.6204, 23.1647],
      惠州市: [114.6204, 23.1647],
      成都: [103.9526, 30.7617],
      成都市: [103.9526, 30.7617],
      扬州: [119.4653, 32.8162],
      扬州市: [119.4653, 32.8162],
      承德: [117.5757, 41.4075],
      承德市: [117.5757, 41.4075],
      拉萨: [91.1865, 30.1465],
      无锡: [120.3442, 31.5527],
      无锡市: [120.3442, 31.5527],
      日照: [119.2786, 35.5023],
      日照市: [119.2786, 35.5023],
      昆明: [102.9199, 25.4663],
      昆明市: [102.9199, 25.4663],
      杭州: [119.5313, 29.8773],
      杭州市: [119.5313, 29.8773],
      枣庄: [117.323, 34.8926],
      枣庄市: [117.323, 34.8926],
      柳州: [109.3799, 24.9774],
      柳州市: [109.3799, 24.9774],
      株洲: [113.5327, 27.0319],
      株洲市: [113.5327, 27.0319],
      武汉: [114.3896, 30.6628],
      武汉市: [114.3896, 30.6628],
      汕头: [117.1692, 23.3405],
      汕头市: [117.1692, 23.3405],
      江门: [112.6318, 22.1484],
      江门市: [112.6318, 22.1484],
      沈阳: [123.1238, 42.1216],
      沈阳市: [123.1238, 42.1216],
      沧州: [116.8286, 38.2104],
      沧州市: [116.8286, 38.2104],
      河源: [114.917, 23.9722],
      河源市: [114.917, 23.9722],
      泉州: [118.3228, 25.1147],
      泉州市: [118.3228, 25.1147],
      泰安: [117.0264, 36.0516],
      泰安市: [117.0264, 36.0516],
      泰州: [120.0586, 32.5525],
      泰州市: [120.0586, 32.5525],
      济南: [117.1582, 36.8701],
      济南市: [117.1582, 36.8701],
      济宁: [116.8286, 35.3375],
      济宁市: [116.8286, 35.3375],
      海口: [110.3893, 19.8516],
      海口市: [110.3893, 19.8516],
      淄博: [118.0371, 36.6064],
      淄博市: [118.0371, 36.6064],
      淮安: [118.927, 33.4039],
      淮安市: [118.927, 33.4039],
      深圳: [114.5435, 22.5439],
      深圳市: [114.5435, 22.5439],
      清远: [112.9175, 24.3292],
      清远市: [112.9175, 24.3292],
      温州: [120.498, 27.8119],
      温州市: [120.498, 27.8119],
      渭南: [109.7864, 35.0299],
      渭南市: [109.7864, 35.0299],
      湖州: [119.8608, 30.7782],
      湖州市: [119.8608, 30.7782],
      湘潭: [112.5439, 27.7075],
      湘潭市: [112.5439, 27.7075],
      滨州: [117.8174, 37.4963],
      滨州市: [117.8174, 37.4963],
      潍坊: [119.0918, 36.524],
      潍坊市: [119.0918, 36.524],
      烟台: [120.7397, 37.5128],
      烟台市: [120.7397, 37.5128],
      玉溪: [101.9312, 23.8898],
      玉溪市: [101.9312, 23.8898],
      珠海: [113.7305, 22.1155],
      珠海市: [113.7305, 22.1155],
      盐城: [120.2234, 33.5577],
      盐城市: [120.2234, 33.5577],
      盘锦: [121.9482, 41.0449],
      盘锦市: [121.9482, 41.0449],
      石家庄: [114.4995, 38.1006],
      福州: [119.4543, 25.9222],
      福州市: [119.4543, 25.9222],
      秦皇岛: [119.2126, 40.0232],
      绍兴: [120.564, 29.7565],
      绍兴市: [120.564, 29.7565],
      聊城: [115.9167, 36.4032],
      聊城市: [115.9167, 36.4032],
      肇庆: [112.1265, 23.5822],
      肇庆市: [112.1265, 23.5822],
      舟山: [122.2559, 30.2234],
      舟山市: [122.2559, 30.2234],
      苏州: [120.6519, 31.3989],
      苏州市: [120.6519, 31.3989],
      莱芜: [117.6526, 36.2714],
      莱芜市: [117.6526, 36.2714],
      菏泽: [115.6201, 35.2057],
      菏泽市: [115.6201, 35.2057],
      营口: [122.4316, 40.4297],
      营口市: [122.4316, 40.4297],
      葫芦岛: [120.1575, 40.578],
      衡水: [115.8838, 37.7161],
      衡水市: [115.8838, 37.7161],
      衢州: [118.6853, 28.8666],
      衢州市: [118.6853, 28.8666],
      西宁: [101.4038, 36.8207],
      西宁市: [101.4038, 36.8207],
      西安: [109.1162, 34.2004],
      西安市: [109.1162, 34.2004],
      贵阳: [106.6992, 26.7682],
      贵阳市: [106.6992, 26.7682],
      连云港: [119.1248, 34.552],
      连云港市: [119.1248, 34.552],
      邢台: [114.8071, 37.2821],
      邢台市: [114.8071, 37.2821],
      邯郸: [114.4775, 36.535],
      邯郸市: [114.4775, 36.535],
      郑州: [113.4668, 34.6234],
      郑州市: [113.4668, 34.6234],
      鄂尔多斯: [108.9734, 39.2487],
      鄂尔多斯市: [108.9734, 39.2487],
      重庆: [107.7539, 30.1904],
      重庆市: [107.7539, 30.1904],
      金华: [120.0037, 29.1028],
      金华市: [120.0037, 29.1028],
      铜川: [109.0393, 35.1947],
      铜川市: [109.0393, 35.1947],
      银川: [106.3586, 38.1775],
      银川市: [106.3586, 38.1775],
      镇江: [119.4763, 31.9702],
      镇江市: [119.4763, 31.9702],
      长春: [125.8154, 44.2584],
      长春市: [125.8154, 44.2584],
      长沙: [113.0823, 28.2568],
      长沙市: [113.0823, 28.2568],
      长治: [112.8625, 36.4746],
      长治市: [112.8625, 36.4746],
      阳泉: [113.4778, 38.0951],
      阳泉市: [113.4778, 38.0951],
      青岛: [120.4651, 36.3373],
      青岛市: [120.4651, 36.3373],
      韶关: [113.7964, 24.7028],
      韶关市: [113.7964, 24.7028],
      乌鲁木齐市: [87.616848, 43.825592],
      五家渠: [87.54324, 44.166756],
      五家渠市: [87.54324, 44.166756],
      巴音郭楞蒙古自治州: [86.145298, 41.764115],
      昌吉回族自治州: [87.308224, 44.011182],
    };
    const convert = (data) => {
      const res = [];
      for (let i = 0; i < data.length; i++) {
        const dataItem = data[i];
        const fromCoord = geoCoordMap[dataItem[0].name];
        const toCoord = geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [fromCoord, toCoord],
          });
        }
      }

      return res;
    };
    this.mapChart.option.series[0].data = convert(mapData.data.mapDatas);
    // this.mapChart.option.series[1].data = mapData.data.mapDatas;
  }
}

function toggleFullScreen() {
  const chins = require('../utils/china');

  if (this.isFullScreen) {
    document.exitFullscreen();
  } else {
    this.$refs.home.requestFullscreen();
  }
  this.isFullScreen = !this.isFullScreen;
}


function toWarningPage() {
  const that = this;
  that.path = '/Warning';
  this.$router.push({
    path: that.path,
  });
}

function toOrderPage() {
  const that = this;
  that.path = '/Order';
  this.$router.push({
    path: that.path,
  });
}

function getDate() {
  const that = this;
  const yy = new Date().getFullYear();
  const mm = new Date().getMonth() + 1;
  const dd = new Date().getDate();
  that.nowDate = `${yy}-${mm}-${dd}`;
}

function drawMain(drawing_elem, percent, forecolor, bgcolor) {
  /*
                  @drawing_elem: 绘制对象
                  @percent：绘制圆环百分比, 范围[0, 100]
                  @forecolor: 绘制圆环的前景色，颜色代码
                  @bgcolor: 绘制圆环的背景色，颜色代码
              */
  const context = drawing_elem.getContext('2d');
  const center_x = drawing_elem.width / 2;
  const center_y = drawing_elem.height / 2;
  const rad = Math.PI * 2 / 100;
  let speed = 0;

  // 绘制背景圆圈
  function backgroundCircle() {
    context.save();
    context.beginPath();
    context.lineWidth = 15; // 设置线宽
    const radius = center_x - context.lineWidth;
    context.lineCap = 'round';
    context.strokeStyle = bgcolor;
    context.arc(center_x, center_y, radius, 0, Math.PI * 2, false);
    context.stroke();
    context.closePath();
    context.restore();
  }

  // 绘制运动圆环
  function foregroundCircle(n) {
    context.save();
    context.strokeStyle = forecolor;
    context.lineWidth = 15;
    context.lineCap = 'round';
    const radius = center_x - context.lineWidth;
    context.beginPath();
    context.arc(center_x, center_y, radius, -Math.PI / 2, -Math.PI / 2 + n * rad, false); // 用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
    context.stroke();
    context.closePath();
    context.restore();
  }

  // 绘制文字
  function text(n) {
    context.save(); // save和restore可以保证样式属性只运用于该段canvas元素
    context.fillStyle = '#fff';
    const font_size = 40;
    context.font = `${font_size}px Helvetica`;
    const text_width = context.measureText(`${n.toFixed(0)}%`).width;
    context.fillText(`${n.toFixed(0)}%`, center_x - text_width / 2, center_y + font_size / 2);
    context.restore();
  }

  // 执行动画
  (function drawFrame() {
    window.requestAnimationFrame(drawFrame);
    context.clearRect(0, 0, drawing_elem.width, drawing_elem.height);
    backgroundCircle();
    text(speed);
    foregroundCircle(speed);
    if (speed >= percent) return;
    speed += 1;
  }());
}

function draw(a, b, c, d) {
  this.drawMain(this.$refs.issued, a, '#1BD0CD', '#6B778B');
  this.drawMain(this.$refs.picking, b, '#FF9744', '#6B778B');
  this.drawMain(this.$refs.review, c, '#4E6FC9', '#6B778B');
  this.drawMain(this.$refs.send, d, '#DF2C5A', '#6B778B');
}

// const planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
// const planePath = 'path://M794.66496,366.24384c-5.95968-8.88832-15.93344-14.2336-26.624-14.2336l-32.01024,0c-17.69472,0-32.01024,14.29504-32.01024,32.01024l0,192c0,17.69472,14.29504,32.01024,32.01024,32.01024l128,0c17.69472,0,32.01024-14.29504,32.01024-32.01024l0-48.00512c0-6.30784-1.88416-12.51328-5.36576-17.75616l-96.01024-143.99488zM864.0512,576l-128,0,0-192,32.01024,0,96.01024,143.99488,0,48.00512zM1007.90272,490.76224l-128-192c-17.85856-26.78784-47.73888-42.76224-79.872-42.76224l-128,0,0-64c0-52.92032-43.06944-96.01024-96.01024-96.01024l-480.01024,0c-52.92032,0-96.01024,43.06944-96.01024,96.01024l0,352.01024c0,52.92032,43.06944,96.01024,96.01024,96.01024l0,0,0,96.01024c0,52.92032,43.06944,96.01024,96.01024,96.01024l36.53632,0c14.29504,55.07072,64,96.01024,123.4944,96.01024,59.43296,0,109.11744-40.91904,123.43296-96.01024l169.02144,0c14.29504,55.07072,64,96.01024,123.4944,96.01024,59.43296,0,109.11744-40.91904,123.43296-96.01024l36.59776,0c52.92032,0,96.01024-43.06944,96.01024-96.01024l0-192c0-19.00544-5.57056-37.43744-16.13824-53.248zM96.0512,576c-17.67424,0-32.01024-14.29504-32.01024-32.01024l0-352.01024c0-17.69472,14.336-32.01024,32.01024-32.01024l480.01024,0c17.69472,0,32.01024,14.29504,32.01024,32.01024l0,352.01024c0,17.69472-14.29504,32.01024-32.01024,32.01024l-480.01024,0zM352.07168,864.01024c-35.36896,0-64-28.672-64-64s28.63104-64,64-64c35.328,0,64,28.672,64,64s-28.71296,64-64,64zM768.04096,864.01024c-35.36896,0-64-28.672-64-64s28.63104-64,64-64c35.328,0,64,28.672,64,64s-28.672,64-64,64zM960.04096,736.01024c0,17.69472-14.29504,32.01024-32.01024,32.01024l-36.57728,0c-14.29504-55.07072-64-96.01024-123.43296-96.01024-59.4944,0-109.17888,40.91904-123.4944,96.01024l-169.02144,0c-14.29504-55.07072-64-96.01024-123.43296-96.01024-59.4944,0-109.17888,40.91904-123.4944,96.01024l-36.57728,0c-17.67424,0-32.01024-14.29504-32.01024-32.01024l0-96.01024,416.01024,0c52.92032,0,96.01024-43.06944,96.01024-96.01024l0-224.01024,128,0c10.69056,0,20.66432,5.34528,26.624,14.2336l128,192c3.4816,5.24288,5.36576,11.44832,5.36576,17.75616l0,192z';
const planePath = 'path://M510.894829,509.878686m-445.630407,0a435.481,435.481,0,1,0,891.260813,0,435.481,435.481,0,1,0-891.260813,0Z';
export default {
  name: 'Home',
  components: {SimpleChart},
  data() {
    return {
      nowDate: '',
      overTime: '',
      abnormal: '',
      allOrders: [],
      receivedOrders: '',
      sendOrders: '',
      isFullScreen: false,
      totalOrderLines: '',
      cancelOrderLines: '',
      issued: '',
      review: '',
      picking: '',
      send: '',
      mapDatas: '',
      deliveryRate: {
        option: {
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            // axisLabel: {
            //     show: true,
            //     textStyle: {
            //         color: '#fff'
            //     }
            // }
          },

          grid: {
            left: '3%',
            right: '10%',
            bottom: '3%',
            top: '10px',
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985',
              },
            },
          },
          yAxis: {
            type: 'value',
            show: false,
            min: 70,
            max: 100,
            splitNumber: 2,
          },
          series: [{
            data: [],
            markLine: {
              symbol: 'none', // 去掉警戒线最后面的箭头
              label: {
                position: 'start', // 将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
              },
              data: [{
                silent: false, // 鼠标悬停事件  true没有，false有
                lineStyle: { // 警戒线的样式  ，虚实  颜色
                  type: 'solid',
                  color: '#FA3934',
                },
                // eslint-disable-next-line max-len
                yAxis: 98, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
              }],
            },
            type: 'line',
            itemStyle: {
              normal: {
                color: '#0F708D', // 折线点的颜色
                lineStyle: {
                  color: '#386db3', // 折线的颜色
                },
              },
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(15,112,141,0.5)', // 0% 处的颜色
                }, {
                  offset: 0.5, color: 'rgba(15,112,141,0.3)', // 100% 处的颜色
                }, {
                  offset: 1, color: 'rgba(15,112,141,0.1)', // 100% 处的颜色
                }],
                global: false, // 缺省为 false
              },
            },
          }],
        },
      },
      orderTop10Chart: {
        option: {
          color: ['#4a5ca5'],
          grid: {
            top: '3%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            show: false,
            type: 'value',
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            axisLabel: {
              color: '#324774',
            },
            axisTick: {
              show: false,
            },
            type: 'category',
            data: '',
          },
          series: [
            {
              type: 'bar',
              itemStyle: {
                normal: {
                  // 好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
                  color(params) {
                    // build a color map as your need.
                    const colorList = [
                      '#0EA997', '#5671D8', '#0EA997', '#5671D8',
                      '#0EA997', '#5671D8', '#0EA997', '#5671D8', '#0EA997', '#5671D8',
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
              data: '',
              barWidth: 8,
              label: {
                show: true,
                position: 'right',
                offset: [5, 1],
              },
            },
          ],
        },
      },
      logisticChart: {
        option: {
          color: ['#14c1fb'],
          grid: {
            top: '8%',
            left: '0%',
            right: '2%',
            bottom: '10%',
            containLabel: false,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985',
              },
            },
          },
          xAxis: {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: '#7285af',
            },
          },
          yAxis: {
            show: false,
            type: 'value',
          },
          series: [
            {
              type: 'bar',
              data: [],
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: 'rgba(114,133,175,0.8)'},
                      {offset: 0.2, color: 'rgba(114,133,175,0.5)'},
                      {offset: 1, color: 'rgba(20,200,212,0)'},
                    ],
                  ),
                },
              },
              barWidth: 8,
            },
          ],
        },
      },
      order: {
        option: {
          color: ['#f8ac59', '#0fb9a6'],
          legend: {
            data: ['超时未送达', '状态异常'],
            textStyle: {
              color: '#2a96fe',
              fontStyle: 'normal',
            },
            itemHeight: 20, // 高
          },
          series: [
            {
              type: 'pie',
              radius: '60%', // 设置饼图大小
              label: {
                formatter: '{b} : {c}',
              },
              data: [],
            },
          ],
        },
      },
      mapChart: {
        option: {
          geo: {
            left: 'center',
            map: 'china',
            zoom: 1,
            silent: true,
            itemStyle: {
              areaColor: '#152036',
              borderColor: 'rgba(0,125,197,0.8)',
              borderWidth: 2,
              // shadowColor: 'rgba(0,125,197,0.8)',
              shadowBlur: 2,
            },
          },
          series: [

            {
              type: 'lines',
              zlevel: 2,
              symbol: ['none'],
              symbolSize(val) {
                return val[2] / 4;
              },
              showEffectOn: 'render',
              lineStyle: {
                normal: {
                  color: '#a4e399',
                  width: 2,
                  opacity: 0.6,
                  curveness: 0.2,
                },
              },
              markPoint: {
                symbol: 'circle',
                symbolSize: 100,
              },
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  formatter: '{b}',
                },
              },
              effect: {
                show: true,
                period: 6,
                trailLength: 0,
                color: '#d9ff57',
                symbol: planePath,
                symbolSize: 5,
              },
              data: '',
            },
            // {
            //     type: 'effectScatter',
            //     coordinateSystem: 'geo',
            //     data: [],
            //     symbolSize: 10,
            //     showEffectOn: 'render',
            //     rippleEffect: {
            //         brushType: 'stroke',
            //     },
            //     hoverAnimation: true,
            //     label: {
            //         normal: {
            //             formatter: '{b}',
            //             position: 'right',
            //             show: true,
            //         },
            //     },
            //     itemStyle: {
            //         // normal: {
            //         //     color: function (x) {
            //         //         return x.data.value[2] % 2 === 0 ? '#1aedda' : '#f1873e';
            //         //     },
            //         //     shadowBlur: 10,
            //         //     shadowColor: '#333',
            //         // },
            //     },
            //     zlevel: 1,
            // },

          ],
        },
      },
    };
  },
  methods: {
    toggleFullScreen,
    toWarningPage,
    toOrderPage,
    drawMain,
    getData,
    getDate,
    draw,
    getTxt
  },
  async mounted() {
    // const res = await getTxt();
    const result = await getDateOrderLines();
    if (result.code === 1200) {
      this.issued = result.data.issued;
      this.review = result.data.review;
      this.picking = result.data.picking;
      this.send = result.data.send;
      this.totalOrderLines = result.data.total;
      this.cancelOrderLines = result.data.cancel;
    }
    const issuedNumber = Math.round((this.issued / this.totalOrderLines) * 100);
    const reviewNumber = Math.round((this.review / this.totalOrderLines) * 100);
    const pickingNumber = Math.round((this.picking / this.totalOrderLines) * 100);
    // const sendNumber = Math.round((this.send / this.totalOrderLines) * 100);
    const sendNumber = 100 - issuedNumber - reviewNumber - pickingNumber;
    if (this.totalOrderLines === 0) {
      this.draw(0, 0, 0, 0);
    } else if (this.issued === 0) {
      this.draw(0, pickingNumber, reviewNumber, sendNumber);
    } else if (this.review === 0) {
      this.draw(issuedNumber, pickingNumber, 0, sendNumber);
    } else if (this.picking === 0) {
      this.draw(issuedNumber, 0, reviewNumber, sendNumber);
    } else if (this.send === 0) {
      this.draw(issuedNumber, pickingNumber, reviewNumber, 0);
    } else {
      this.draw(issuedNumber, pickingNumber, reviewNumber, sendNumber);
    }
    this.getDate();
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.time-graph {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}

.cricle-rate {
  width: 100px;
  height: 100px;
}

.home {
  width: 100%;
  height: 110%;
  background-size: 100% auto;
  background: rgb(27, 42, 71) url("../assets/home/home_bg.png") no-repeat top;
}

.home-main {
  position: relative;
  height: calc(100% - 60px);
  width: 100%;
}

.home-header {
  cursor: pointer;
  text-align: center;
  color: #ACB6E5;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  background: -webkit-linear-gradient(90deg, #2a7aea, #ffffff);
  font-weight: 700;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.order-num-wrap {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
}

.order-num-title {
  color: #a0dcfd;
  height: 50px;
  line-height: 50px;
}

.order-num-tag {
  display: inline-block;
  width: 55px;
  height: 70px;
  font-size: 40px;
  font-weight: 700;
  line-height: 70px;
  background: #152036;
  color: #ffffff;
  text-align: center;
  margin-right: 5px;
}

.order-status-wrap {
  position: absolute;
  left: 400px;
  top: 50px;
}

.order-status-tag {
  width: 140px;
  display: inline-block;
  text-align: center;
  /*padding: 0 10px 10px;*/
}

.order-status {
  font-size: 30px;
}

.order-status-title {
  color: #fff;
  margin-bottom: 5px;
}

.info-wrap {
  border: 1px solid #324774;
}

.info-content-split {
  background: url("../assets/home/split.png") no-repeat top;
  height: 5px;
  background-size: 100% auto;
  margin: 5px 30px;
}

.info-title {
  background-size: 100% auto;
  text-align: center;
  color: #ffffff;
  margin-top: -20px;
  font-size: 16px;
  height: 40px;
  line-height: 41px;
  background: url("../assets/home/info_title_bg.png") no-repeat top;
}

.info-overtime {
  background: url("../assets/home/overtime.png") no-repeat top;
  height: 70px;
  color: #B8CEDA;
  font-size: 14px;
}

.info-retention {
  background: url("../assets/home/retention.png") no-repeat top;
  height: 70px;
  color: #B8CEDA;
  font-size: 14px;
}

.info-error {
  background: url("../assets/home/error.png") no-repeat top;
  height: 70px;
  color: #B8CEDA;
  font-size: 14px;
}

.info-overtime .title, .info-retention .title, .info-error .title {
  margin-left: 120px;
  color: #B8CEDA;
  font-size: 14px;
  line-height: 40px;
}

.info-overtime .detail span {
  color: #1AEDDA;
  font-size: 38px;
}

.info-retention .detail span {
  color: #F1873E;
  font-size: 38px;
}

.info-error .detail span {
  color: #2A96FE;
  font-size: 38px;
}

.info-overtime .detail, .info-retention .detail, .info-error .detail {
  color: #B8CEDA;
  font-size: 14px;
  line-height: 4px;
  text-align: right;
  margin-right: 80px;
}

.order-hover:hover {
  cursor: pointer;
}

</style>
